// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ColoringIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ColoringIcon" ref={forwardedRef} {...props}>
      <path d="m5.477 1.47 2.611 2.61 6.908 6.347-5.073 5.523a3 3 0 0 1-4.24.18l-2.577-2.368a3 3 0 0 1-.18-4.239l4.062-4.421L4.416 2.53zM8.09 6.12l-4.06 4.417a1.5 1.5 0 0 0-.382 1.212h8.095l1.133-1.233z" />
      <path d="M18.105 16.772c.193-.54.116-1.138-.075-1.679-.595-1.68-1.905-2.843-1.905-2.843s-1.242 1.071-1.868 2.76c-.22.594-.315 1.258-.08 1.845.328.821 1.077 1.395 1.948 1.395.9 0 1.67-.613 1.98-1.478" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ColoringIcon = /* @__PURE__ */ Object.assign(
  ColoringIconComponent,
  { displayName: 'ColoringIcon' },
);
